// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","disclaimerBox":"disclaimer_disclaimerBox__yanZT"};